import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { productionGroupsLoaded } from '../store/productionGroupsSlice';
import { AsyncThunkActionVoid } from './thunkActions';

/**
 * When the app starts we only load the active production groups. When looking at the history, we want to see data from
 * production groups that are not active.
 */
export function loadProductionGroupsForProject(projectGuid: string, spinner = true): AsyncThunkActionVoid {
  return async function loadProductionGroupsForProjectThunkAction(dispatch) {
    const spinnerId = spinner ? dispatch(addSpinnerMessage('Loading production groups for project...')) : null;
    try {
      const productionGroups = await designService.productionGroups.getForProject(projectGuid);
      dispatch(productionGroupsLoaded(productionGroups));
    } catch (error) {
      console.error(error);
      dispatch(enqueueError('Error loading production groups for project'));
    } finally {
      if (spinnerId) dispatch(removeSpinnerMessage(spinnerId));
    }
  };
}
